import { TdsItem } from '@tencent/tds-ui/src/enum/tds';
import { TdsFooter } from '@tencent/tds-ui/src/tds-footer';
import { TdsNavigation } from '@tencent/tds-ui/src/tds-navigation';
import { Button, Space, Table } from 'antd';
import classNames from 'classnames';
import React, { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BrandLogo from '@/assets/images/header/brand-logo.svg?react';
import AlertIcon from '@/assets/images/index-mobile/alert.react.svg?react';
import HomeAnimationIcon from '@/assets/images/index-mobile/animation.react.svg?react';
import CoreIcon from '@/assets/images/index-mobile/core.react.svg?react';
import ExtraIcon from '@/assets/images/index-mobile/extra.react.svg?react';
import InfoIcon from '@/assets/images/index-mobile/info.react.svg?react';
import MetricIcon from '@/assets/images/index-mobile/metric.react.svg?react';
import ReportIcon from '@/assets/images/index-mobile/report.react.svg?react';
import UserListIcon from '@/assets/images/index-mobile/user-list.react.svg?react';
import alarm1x from '@/assets/images/index/1x/alarm1x.png';
import appList1x from '@/assets/images/index/1x/app-list1x.png';
import compared1x from '@/assets/images/index/1x/compared1x.png';
import core1x from '@/assets/images/index/1x/core1x.png';
import customDataAnalysis1x from '@/assets/images/index/1x/custom-data-analysis1x.png';
import daily1x from '@/assets/images/index/1x/daily1x.png';
import fd1x from '@/assets/images/index/1x/fd1x.png';
import flameGraph1x from '@/assets/images/index/1x/flame-graph1x.png';
import foom1x from '@/assets/images/index/1x/foom1x.png';
import schedulingSequenceChart1x from '@/assets/images/index/1x/scheduling-sequence-chart1x.png';
import search1x from '@/assets/images/index/1x/search1x.png';
import symbolTable1x from '@/assets/images/index/1x/symbol-table1x.png';
import tombstone1x from '@/assets/images/index/1x/tombstone1x.png';
import trendAnalysis1x from '@/assets/images/index/1x/trend-analysis1x.png';
import alarm2x from '@/assets/images/index/2x/alarm2x.png';
import appList2x from '@/assets/images/index/2x/app-list2x.png';
import compared2x from '@/assets/images/index/2x/compared2x.png';
import core2x from '@/assets/images/index/2x/core2x.png';
import customDataAnalysis2x from '@/assets/images/index/2x/custom-data-analysis2x.png';
import daily2x from '@/assets/images/index/2x/daily2x.png';
import fd2x from '@/assets/images/index/2x/fd2x.png';
import flameGraph2x from '@/assets/images/index/2x/flame-graph2x.png';
import foom2x from '@/assets/images/index/2x/foom2x.png';
import schedulingSequenceChart2x from '@/assets/images/index/2x/scheduling-sequence-chart2x.png';
import search2x from '@/assets/images/index/2x/search2x.png';
import symbolTable2x from '@/assets/images/index/2x/symbol-table2x.png';
import tombstone2x from '@/assets/images/index/2x/tombstone2x.png';
import trendAnalysis2x from '@/assets/images/index/2x/trend-analysis2x.png';
import alarm3x from '@/assets/images/index/3x/alarm3x.png';
import appList3x from '@/assets/images/index/3x/app-list3x.png';
import compared3x from '@/assets/images/index/3x/compared3x.png';
import core3x from '@/assets/images/index/3x/core3x.png';
import customDataAnalysis3x from '@/assets/images/index/3x/custom-data-analysis3x.png';
import daily3x from '@/assets/images/index/3x/daily3x.png';
import fd3x from '@/assets/images/index/3x/fd3x.png';
import flameGraph3x from '@/assets/images/index/3x/flame-graph3x.png';
import foom3x from '@/assets/images/index/3x/foom3x.png';
import schedulingSequenceChart3x from '@/assets/images/index/3x/scheduling-sequence-chart3x.png';
import search3x from '@/assets/images/index/3x/search3x.png';
import symbolTable3x from '@/assets/images/index/3x/symbol-table3x.png';
import tombstone3x from '@/assets/images/index/3x/tombstone3x.png';
import trendAnalysis3x from '@/assets/images/index/3x/trend-analysis3x.png';
import IconCheck from '@/assets/images/page/check.react.svg?react';
import IconClose from '@/assets/images/page/close.react.svg?react';
import IconLoading from '@/assets/images/page/loading-blue.png';
import IconTDS from '@/assets/images/public/ico-tds.svg';
import IconBugly from '@/assets/images/public/icon-bugly.svg';
import { MultiApp, useAppConfig } from '@/config/context';
import { userImplement } from '@/config/hooks/user';
import { isSgp } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick, useReportPage } from '@/infrastructure/reporter/datong/report';
import { AppSlot } from '@/presentation/components/app-slot';
import { SgpFooterFull } from '@/presentation/components/sgp-footer';
import { useAuthContext } from '@/presentation/hooks';
import { useMobile } from '@/presentation/hooks/utils/mobile';
import { ContactUs } from '@/presentation/layouts/tools/contact-us';
import { Features, ISegmentedList } from '@/presentation/pages/main-pro/features';
import { Header } from '@/presentation/pages/main-pro/header';
import { TDSHeader } from '@/presentation/pages/main-pro/tds-header';
import { HomeAnimation } from './homeAnimation';

import style from './index.module.scss';
import { Menu } from './menu';

const iconMap: Record<string, any> = {
  close: <IconClose />,
  check: <IconCheck />,
  loading: <img src={IconLoading} width={20} />,
};

export const TDSMainPage = () => {
  const history = useHistory();
  const { authInfo } = useAuthContext();
  useReportPage(PAGE_ID.indexMain);
  const config = useAppConfig();
  const [isMobile] = useMobile();

  useLayoutEffect(() => {
    const link = document.querySelector('link[rel*=\'shortcut icon\']');
    if (!link) {
      return;
    }
    document.title = '监控定位—tds-Bugly';
    link.setAttribute('href', IconTDS);
    return () => {
      link.setAttribute('href', IconBugly);
      document.title = 'Bugly';
    };
  }, []);

  const getFeatureContent = () => (
    <div className={style.tagContainer}>
      <div className={style.subContent}>
        <div>
          <div className={style.headline}>监控能力升级</div>
          <div className={style.desc}>在崩溃监控的基础上，增加了卡顿监控、内存监控以及启动监控，全面捕获质量问题。</div>
        </div>
      </div>
      <div><img className={style.img} src={core2x} srcSet={`${core1x} 1x, ${core2x} 2x, ${core3x} 3x`} alt=''/></div>
    </div>
  );

  const quickStart = () => {
    if (!authInfo.isLoggedIn) {
      userImplement.logout();
      return;
    }
    history.push('/workbench/apps');
  };

  const fieldInformationSegmented: ISegmentedList[] = [
    { txt: '通过进程FD列表信息和FD分配函数堆栈，可以快速分析FD相关疑难问题的原因；', img: [fd1x, fd2x, fd3x] },
    { txt: '通过tombstone文件可以查看native crash问题每个线程的寄存器上下文以及函数栈内容；', img: [tombstone1x, tombstone2x, tombstone3x] },
    { txt: 'Android ANR监控支持Message消息调度时序图，可以了解ANR之前每个消息的耗时以及调度时序关系，并且可以快速查找ANR之前60秒的卡顿堆栈；', img: [schedulingSequenceChart1x, schedulingSequenceChart2x, schedulingSequenceChart3x] },
    { txt: 'iOS ANR监控支持通过火焰图和堆栈树查看卡死现场，协助用户快速定位导致卡死的直接原因；', img: [flameGraph1x, flameGraph2x, flameGraph3x] },
  ];
  const dataAnalysisSegmented: ISegmentedList[] = [
    { txt: '支持丰富的搜索字段，支持多种匹配规则，方便用户随心所欲查询指定数据；', img: [search1x, search2x, search3x] },
    { txt: '支持灵活的统计分析能力，帮助用户自由分析特定条件下的变化趋势及分布情况；', img: [trendAnalysis1x, trendAnalysis2x, trendAnalysis3x] },
    { txt: '支持条件对比功能，协助用户快速定位新增问题、劣化问题；', img: [compared1x, compared2x, compared3x] },
    { txt: '支持自定义数据分析及功能联动，关联各类异常问题，为解决疑难问题提供新思路；', img: [customDataAnalysis1x, customDataAnalysis2x, customDataAnalysis3x] },
  ];
  const otherFeaturesSegmented: ISegmentedList[] = [
    { txt: '支持FOOM监控，提供更丰富的内存信息，协助用户定位内存使用异常问题；', img: [foom1x, foom2x, foom3x] },
    { txt: '支持多种符号表上传方式，网页上传更便捷，工具上传更灵活；', img: [symbolTable1x, symbolTable2x, symbolTable3x] },
    { txt: '支持多任务、多维度、多策略告警，告警更及时，通知更清晰，权限更规范；', img: [alarm1x, alarm2x, alarm3x] },
    { txt: '提供全面的质量日报数据，快速了解应用质量现状，支持业务自由配置；', img: [daily1x, daily2x, daily3x] },
  ];

  const renderIconWithTip = (iconType: string, tip: string) => {
    const icon = iconMap[iconType];
    return <Space>
      <span className={style.tipIcon}>{icon}</span>
      <span>{tip}</span>
    </Space>;
  };

  const dataSource = [
    {
      feature: '费用情况',
      platform: '全平台',
      bugly: '免费',
      buglyPro: '收费，可以按照事件量或MAU购买',
    },
    {
      feature: '指标体系',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更多的指标信息'),
    },
    {
      feature: '崩溃捕获',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更多的现场信息'),
    },
    {
      feature: 'ANR',
      platform: 'Android',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更多的现场信息'),
    },
    {
      feature: 'ANR',
      platform: 'iOS',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持，提供异常期间的堆栈信息'),
    },
    {
      feature: '卡顿监控',
      platform: 'Android',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更准确的堆栈信息'),
    },
    {
      feature: '卡顿监控',
      platform: 'iOS',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更准确的堆栈信息'),
    },
    {
      feature: '内存分析',
      platform: 'Android',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持java内存泄露、fd触顶、native内存触顶分析'),
    },
    {
      feature: '内存分析',
      platform: 'iOS',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持内存图、vc内存泄露、大内存配置监控等多维分析'),
    },
    {
      feature: 'FOOM',
      platform: 'iOS',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持，提供更多现场信息'),
    },
    {
      feature: '自定义聚类',
      platform: '全平台',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持，支持配置自定义'),
    },
    {
      feature: '功能配置采样',
      platform: '全平台',
      bugly: renderIconWithTip('close', '不支持'),
      buglyPro: renderIconWithTip('check', '支持'),
    },
    {
      feature: '告警',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '告警维度更加丰富，告警更加及时'),
    },
    {
      feature: '符号表上传',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持工具上传和拖拽上传'),
    },
    {
      feature: '数据下钻',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持更多字段更多维度的下钻分析'),
    },
    {
      feature: '页面响应效率',
      platform: '全平台',
      bugly: renderIconWithTip('loading', '响应慢'),
      buglyPro: renderIconWithTip('check', '秒级响应'),
    },
    {
      feature: '日报展示',
      platform: '全平台',
      bugly: renderIconWithTip('check', '支持'),
      buglyPro: renderIconWithTip('check', '支持展示更多指标及变化趋势'),
    },
  ];

  /*  const gotoBusinessConsult = () => {
    history.push('/consult');
  };*/

  const overseasClick = () => {
    reportClick(PAGE_ID.indexMain, CUSTOM_ACTIONS.commonEnterOverseas, {
      from: PAGE_ID.indexMain,
    });
    const a = document.createElement('a');
    a.href = 'https://bugly.tds.tencent.com/v2/index/main';
    a.target = '_blank';
    a.click();
  };

  const docsClick = () => {
    window.open(config.docRoot, '_blank');
  };

  return (
    <div className={style.main}>
      <AppSlot apps={[MultiApp.Pro]}>
        <TdsNavigation isWoa={false} isProd={ENV.isProd} activeMenu={TdsItem.Bugly} isMobile={isMobile} />
        <TDSHeader />
      </AppSlot>
      <AppSlot apps={[MultiApp.Sgp]}>
        <Header />
      </AppSlot>
      <div className={classNames(style.introduce, isSgp() ? style.introduceSgp : '')}>
        <div className={style.brandTitle}>
            <BrandLogo/>
            <AppSlot apps={[MultiApp.Pro]}>
              <span className={style.brandText}>tds-Bugly</span>
            </AppSlot>
            <AppSlot apps={[MultiApp.Sgp]}>
              <span className={style.brandText}>Bugly</span>
            </AppSlot>
          </div>
          <div className={style.introduceTitle}>
            <span>一种愉悦的开发方式</span>
          </div>
        <AppSlot apps={[MultiApp.Pro]}>
          <div className={style.introduceContent}>
            Bugly​ 是专业的应用质量监控与定位分析平台，致力于提供覆盖研发全流程、全平台、智能化的监控定位分析解决方案，
              助力全球开发者高效地构建高质量应用。 作为腾讯端服务（Tencent Device-oriented
              Service，简称TDS）产品联盟的核心成员，Bugly与联盟伙伴携手共建开放共赢的大前端技术生态圈。
          </div>
        </AppSlot>
        <AppSlot apps={[MultiApp.Sgp]}>
          <div className={style.introduceContent}>
            Bugly​ 是专业的应用质量监控与定位分析平台，致力于提供覆盖研发全流程、全平台、智能化的监控定位分析解决方案，
              助力全球开发者高效地构建高质量应用。
          </div>
        </AppSlot>
        <HomeAnimationIcon className={style.animation} />
        <div className={style.btnContainerMobile}>
          <Space size={'middle'}>
            <Button
              size={'large'}
              type={'primary'}
              className={style.introduceBtn}
              onClick={quickStart}
            >
              开始使用
            </Button>
            <Button
              size={'large'}
              type={'default'}
              className={style.qa}
              onClick={() => {
                window.open('https://work.weixin.qq.com/ca/cawcdeff02796a78e6');
              }}
            >
              商务咨询
            </Button>
          </Space>
        </div>
        <Menu />
        <div className={style.btnContainer}>
          <Space size={'middle'}>
            <Button
              size={'large'}
              type={'primary'}
              className={style.introduceBtn}
              onClick={quickStart}
            >
              开始使用
            </Button>
            <Button
              size={'large'}
              type={'default'}
              className={style.freeTrialBtn}
              onClick={docsClick}
            >
              文档中心
            </Button>
            {!ENV.isGlobal ? <Button
              size={'middle'}
              type={'link'}
              onClick={overseasClick}
            >
              海外版 <span className={'ml-[4px]'}>{'>'}</span>
            </Button> : null}
          </Space>
        </div>
        <HomeAnimation />
      </div>
      <div className={style.feature}>
        <div className={style.bigTitle}>核心功能</div>
        <div className={style.featureTag}>{getFeatureContent()}</div>
      </div>
      {/* mobile */}
      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>监控能力升级</div>
        <div className={style.featureContent}>
        在崩溃监控的基础上，增加了卡顿监控、内存监控以及启动监控，全面捕获质量问题。
        </div>
        <div className={style.featureImg}>
          <CoreIcon />
        </div>
      </div>

      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>丰富的指标体系</div>
        <div className={style.featureContent}>
        除崩溃率、ANR率、错误率外，增加了FPS、挂起率、FOOM率、内存峰值以及启动耗时等指标。
        </div>
        <div className={style.featureImg}>
          <MetricIcon />
        </div>
      </div>

      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>更多现场信息</div>
        <div className={style.featureContent}>
        在异常堆栈及跟踪数据的基础上，增加了内存，进程，线程，FD以及更多系统日志等现场信息，方便用户分析疑难问题。
        </div>
        <div className={style.featureImg}>
          <InfoIcon />
        </div>
      </div>

      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>扩展分析能力</div>
        <div className={style.featureContent}>
        通过下钻分析和对比分析，轻松掌握Issue变化情况，上报趋势以及多维度的统计分布特性。
        </div>
        <div className={style.featureImg}>
          <ExtraIcon />
        </div>
      </div>

      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>多策略告警</div>
        <div className={style.featureContent}>
        提供多任务，多维度，多策略告警支持，告警通知更清晰，权限管理更规范。
        </div>
        <div className={style.featureImg}>
          <AlertIcon />
        </div>
      </div>

      <div className={style.mobileFeature}>
        <div className={style.bigTitle}>可配置日报</div>
        <div className={style.featureContent}>
        提供全面的质量日报数据，快速了解应用质量现状，支持业务自由配置。
        </div>
        <div className={style.featureImg}>
          <ReportIcon />
        </div>
      </div>
      {/* mobile end */}
      <Features
        title={'多样的现场信息'}
        segmentedList={fieldInformationSegmented}
        className={style.fieldInformation}
      />
      <Features
        title={'强大的数据分析能力'}
        segmentedList={dataAnalysisSegmented}
      />
      <Features
        title={'更多其他特性'}
        segmentedList={otherFeaturesSegmented}
        className={style.otherFeatures}
      />

      {/* 对比 */}
      {!ENV.isGlobal && (
        <div className={style.compareTableContainer}>
          <div className={style.compareHeader}>Bugly与Bugly专业版对比</div>
          <Table
            className={style.compareTable}
            dataSource={dataSource}
            bordered
            pagination={false}
            rowClassName={(_, index: number) => {
              // highlight的行
              if ([1, 3, 4, 7, 8, 10, 12, 14, 16].includes(index)) {
                return style.highlightRow;
              }

              return style.normalRow;
            }}
          >
            <Table.Column
              title={'功能项'}
              dataIndex={'feature'}
              width={180}
              onCell={(_, index) => {
                // 合并单元格
                if ([3, 5, 7].includes(index as number)) {
                  return { rowSpan: 2 };
                }

                if ([4, 6, 8].includes(index as number)) {
                  return { rowSpan: 0 };
                }

                return {};
              }}
            />
            <Table.Column title={'平台'} dataIndex={'platform'} width={180} />
            <Table.Column title={'Bugly'} dataIndex={'bugly'} width={320} />
            <Table.Column
              title={'Bugly专业版'}
              dataIndex={'buglyPro'}
              width={520}
            />
          </Table>
        </div>
      )}

      {!ENV.isGlobal && (
        <div className={style.userList}>
          <div className={style.bigTitle}>他们也选择了Bugly</div>
          <img
            srcSet={`${appList1x} 1x, ${appList2x} 2x, ${appList3x} 3x`}
            className={style.picture}
            alt=""
          />
          <UserListIcon className={style.mobileImg} />
        </div>
      )}
      <div className={style.startUse}>
        <div className={style.bigTitle}>
          让我们现在就开始体验Bugly {config.subBrandText}
        </div>
        <Button
          type={'primary'}
          size={'large'}
          className={style.startUseBtn}
          onClick={quickStart}
        >
          开始使用
        </Button>

        <AppSlot apps={[MultiApp.Pro]}>
          <TdsFooter
            isProd={ENV.isProd}
            icp={'粤B2-20090059'}
            icpURL={'https://beian.miit.gov.cn/#/Integrated/index'}
            isWoa={false}
          />
        </AppSlot>

        <AppSlot apps={[MultiApp.Sgp]}>
          <SgpFooterFull
            showPcgTerm={false}
            locale={ENV.isGlobal ? 'EN' : 'ZH_CN'}
            icp={'粤B2-20090059'}
            icpURL={'https://beian.miit.gov.cn/#/Integrated/index'}
            serviceTermUrl={'https://bugly.tds.tencent.com/docs/other/Bugly_Terms_Of_Service'}
            privacyPolicyUrl={'https://bugly.tds.tencent.com/docs/other/Bugly_Privacy_Policy'}
            copyRight='Copyright © 2024 Hong Kong Gathering Media Limited. All Rights Reserved.'
          />
        </AppSlot>
      </div>
      <ContactUs />
    </div>
  );
};
